import { createContext, useContext, useState, useCallback } from "react";

/**
 * Admin oturumu — secret YALNIZCA bellekte tutulur.
 *
 * Bilerek localStorage/sessionStorage kullanilmiyor: orada duran bir secret
 * XSS ile calinabilir ve sayfa kapansa bile diskte kalir. Sayfa yenilenince
 * admin tekrar giris yapar; bu kasitli bir denge.
 *
 * Secret sunucuya HER ZAMAN X-Admin-Secret header'i ile gider (query string
 * degil) — query string'deki secret proxy/erisim loglarina ve tarayici
 * gecmisine sizar.
 */
const AdminContext = createContext(null);

export function AdminProvider({ children }) {
  const [secret, setSecret] = useState(null);

  const login  = useCallback((pw) => setSecret(pw), []);
  const logout = useCallback(() => setSecret(null), []);

  return (
    <AdminContext.Provider value={{ secret, isAdmin: !!secret, login, logout }}>
      {children}
    </AdminContext.Provider>
  );
}

export function useAdmin() {
  const ctx = useContext(AdminContext);
  if (!ctx) throw new Error("useAdmin, AdminProvider icinde kullanilmali");
  return ctx;
}
